import { Tag } from "@chakra-ui/tag";
import { Flex } from "@chakra-ui/layout";

function useGrupoDescontoColumns() {
  return [
    {
      title: "Nome",
      dataIndex: "nome",
      width: "70%",
      render: (nome: string) => nome,
    },
    {
      title: "",
      dataIndex: "destino",
      width: "25%",
      render: (destino: string) => (
        <Flex w="100%">
          <Tag
            variant="outline"
            colorScheme="blue"
            ml="auto"
            rounded="full"
            textAlign="center"
            py={1}
            noOfLines={1}
          >
            {destino}
          </Tag>
        </Flex>
      ),
    },
  ];
}

export default useGrupoDescontoColumns;
